import { Grid, Typography } from '@mui/material'

const FinancialDataTotalOverview = ({ financialData }) => {
  const currentYear = new Date().getFullYear()
  const lastYear = currentYear - 1

  if (!financialData) {
    return null
  }

  const variant = 'h6'
  const fontSize = '23px'
  const boldNumberStyle = {
    fontWeight: '700',
    height: '30px',
    letterSpacing: '1px',
  }

  const convertCentsToAmount = (field) => {
    const value =
      financialData.reduce((total, item) => total + (item[field] || 0), 0) / 100
    return isFinite(value) ? Math.round(value) : 0
  }

  const calculateRatio = (number1, number2) => {
    return isFinite(number1 / number2) ? (number1 / number2) * 100 : 0
  }

  const totalBudget = convertCentsToAmount('totalAmountCents')
  const totalRealized = convertCentsToAmount('totalAmountRealizedCents')
  const totalRealizedN1 = convertCentsToAmount('lastYearAmountRealizedCents')

  const ratioBudget = calculateRatio(totalRealized, totalBudget)
  const ratioRealise = calculateRatio(totalRealizedN1, totalRealized)

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} sm={6} md={4}>
        <Grid
          container
          spacing={2}
          style={{
            border: '1px solid #c9c9c9',
            borderRadius: '5px',
            marginTop: '0px',
            paddingRight: '10px',
          }}
        >
          <Grid item xs={6} style={{ paddingTop: '10px' }}>
            <Typography
              variant={variant}
            >{`Budget total ${currentYear} :`}</Typography>
            <Typography
              variant={variant}
            >{`Réalisé total ${currentYear} :`}</Typography>
            <Typography
              variant={variant}
            >{`Budget atteint ${currentYear} :`}</Typography>
          </Grid>
          <Grid item xs={6} style={{ textAlign: 'right', paddingTop: '10px' }}>
            <Typography
              variant={variant}
              sx={{ ...boldNumberStyle, fontSize: fontSize }}
            >
              {totalBudget.toLocaleString('fr-FR', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 0,
              })}
            </Typography>
            <Typography
              variant={variant}
              sx={{ ...boldNumberStyle, fontSize: fontSize }}
            >
              {totalRealized.toLocaleString('fr-FR', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 0,
              })}
            </Typography>
            <Typography
              variant={variant}
              sx={{ ...boldNumberStyle, fontSize: fontSize }}
            >
              {ratioBudget.toFixed(1)} %
            </Typography>
          </Grid>
          <Grid item xs={6} style={{ paddingTop: '5px' }}>
            <Typography
              variant={variant}
            >{`Réalisé total ${lastYear} :`}</Typography>
            <Typography
              variant={variant}
            >{`Budget ${lastYear} / ${currentYear} :`}</Typography>
          </Grid>
          <Grid item xs={6} style={{ textAlign: 'right', paddingTop: '5px' }}>
            <Typography
              variant={variant}
              sx={{ ...boldNumberStyle, fontSize: fontSize }}
            >
              {totalRealizedN1.toLocaleString('fr-FR', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 0,
              })}
            </Typography>
            <Typography
              variant={variant}
              sx={{ ...boldNumberStyle, fontSize: fontSize }}
            >
              {ratioRealise.toFixed(1)} %
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            style={{ paddingTop: '2px', paddingBottom: '2px' }}
          >
            <Typography sx={{ fontStyle: 'italic', fontSize: '15px' }}>
              *Hors charges exceptionnelles
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default FinancialDataTotalOverview
